const STORE_KEY = process.env.VUE_APP_STORE_KEY

module.exports = {
  MEDIA_PATH: process.env.VUE_APP_MEDIA_PATH,
  IMAGES_URL: process.env.VUE_APP_IMAGES_URL,
  VIDEOS_URL: process.env.VUE_APP_VIDEOS_URL,
  UPLOAD_ENDPOINT: process.env.VUE_APP_UPLOAD_ENDPOINT,
  ADMIN_TOKEN_KEY: `${STORE_KEY}-admin-token`,

  meta: {
    title: 'spencer madsen',
    description: 'Website Spencer Madsen (b. 1992)',
    thumb: '/thumbnail.png'
  },

  screens: {
    xxs: 319,
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1200,
    xxl: 1400
  },

  colors: {
    transparent: 'transparent',
    white: '#fff',
    winGray: '#c0c0c0',
    gray: '#808080',
    copy: '#22292f',
    black: '#000',
    winBlue: '#000082',
    blue: '#00f',
    red: '#f00',
    green: '#228b22'
  }
}
